<template>
    <div id="front-videos">
        <section class="video-descriptions">
            <p>Here is a sampling of the many great programs and services Overlake has to offer:</p>
            <div v-for="(video, i) in videos" v-bind:key="i" v-html="video.description"></div>
        </section>
        <a href="/about">
            <img
                    id="logo-front" class="shadow"
                    src="https://www.overlake.org/sites/default/files/pictures/branding/logo-front.png"
                    alt="About the Overlake School"
            >
        </a>
        <div id="controls">
            <div v-show="showInfo" id="video-info" class="shadow" v-html="description"></div>
            <font-awesome-icon id="btn-pause" class="shadow" :icon="paused ? iconPlay : iconPause"/>
            <font-awesome-icon id="btn-info" class="shadow" :icon="iconInfo" @click="toggleInfo"/>
        </div>
        <div id="videos">
            <div id="paused">
                <font-awesome-icon v-show="paused" class="shadow" :icon="iconPlay"/>
            </div>
            <Video v-for="(video, index) in videos"
                   :key="'video-' + index"
                   :ref="'video-' + index"
                   :index="index"
                   :video="video"
                   :top-index="topIndex"
                   @ended="switchVideos"
            />
        </div>
    </div>
</template>

<script>

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faInfoCircle, faPause, faPlay} from '@fortawesome/free-solid-svg-icons'
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
    import {videoList} from '../video-list.json'

    import {mapState} from 'vuex';

    import Video from './Video.vue';

    export default {
        name: 'Front',
        components: {
            FontAwesomeIcon,
            Video,
        },
        computed: {
            ...mapState([
                'paused'
            ]),

        },
        data() {
            library.add(faInfoCircle, faPause, faPlay);
            return {
                iconInfo: faInfoCircle,
                iconPause: faPause,
                iconPlay: faPlay,
                showInfo: false,
                videos: [],
                description: '',
                topIndex: 0,
            }
        },
        created() {
            if(window.drupalSettings && window.drupalSettings.homeHeroVideos) {
              let randSetIndex = Math.floor(Math.random() * Math.floor(window.drupalSettings.homeHeroVideos.length));
              this.videos = window.drupalSettings.homeHeroVideos[randSetIndex];
            }
        },
        mounted() {
            if (!this.paused) {
                this.$refs['video-0'][0].play();
                this.description = this.videos[0].description;
            }
        },
        methods: {
            switchVideos(index) {
                if (!this.paused) {
                    let nextIndex = (index + 1) % 3;
                    this.$refs['video-' + nextIndex][0].play();
                    // Reset here so we don't have a blip on the next cycle
                    this.$refs['video-' + index][0].reset();
                    this.topIndex = nextIndex;
                    this.description = this.videos[nextIndex].description;
                }
            },
            toggleInfo() {
                this.showInfo = !this.showInfo;
            },
        },
    }
</script>

<style lang="scss">

    // From old video.css
    #front-videos {
        background: url('https://www.overlake.org/sites/default/files/images/fallback.jpg') center no-repeat;
        background-size: cover;
        height: 100vh;
        width: 100vw;
        position: relative;
        margin-bottom: 2rem;
        @media all and (max-width: 768px) {
          height: 65vh;
        }
    }

    #main-menu { /* Region needs to load so menu content can be duplicated into slider nav, but shouldn't be visible */
        display: none;
    }

    .layout-sidenav {
        margin-right: -352px; /* Open position is farther left so text can be seen */
    }

    // End old video.css

    #controls {
        z-index: 3;
        position: absolute;
        color: white;
        pointer-events: none;
        bottom: 1rem;
        right: 2rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        width: 280px;
    }

    #controls * {
        opacity: 0.8;
    }

    #controls #btn-info,
    #controls #video-info a {
        pointer-events: all;
    }

    #controls #btn-info {
        padding: 0.5rem;
        font-size: 2rem;
    }

    #controls #btn-pause {
        font-size: 1.5rem;
        padding: 0.75rem;
    }

    #controls svg:hover {
        opacity: 1;
    }

    #controls svg:active {
        opacity: 0.7;
    }

    #video-info {
        position: relative;
        right: 0.75rem;
        bottom: 1rem;
        color: var(--color-text);
        background-color: white;
        padding: 1rem;
        width: 100%;
        font-size: 0.9rem;
    }

    #video-info::after {
        content: '';
        position: absolute;
        top: 100%;
        right: 1rem;
        border-top: 15px solid white;
        border-left: 15px solid transparent;
    }

    // Video Styles
    #paused {
        position: absolute;
        z-index: 4;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 100vh;
        pointer-events: none;
    }

    #paused * {
        z-index: 2;
        color: white;
        font-size: 5rem;
        font-weight: bold;
        opacity: 0.7;
    }

    #videos {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    // Accessibility
    .video-descriptions {
        left: -9999px;
        position: absolute;
    }

</style>
